export const DAY_USE_CODE = 'DYOFF_WEB';
